import React from 'react';
import { Field, useFormikContext } from 'formik';
import { ScheduledTransferFrequencyUnit } from '@tradingblock/types';
import { FormGroup, TextboxField, SelectDropdownInput } from '@tradingblock/components';
import { DateField } from '../../../components/form/DateField';
import { CashieringViewFormValues } from './data/useCashieringView';

interface ScheduledTransferFieldsProps {
  values: CashieringViewFormValues;
}

export const ScheduledTransferFields: React.FC<ScheduledTransferFieldsProps> = ({ values }) => {
  const { setFieldValue } = useFormikContext<CashieringViewFormValues>();
  const transfer = values.transfer;

  const frequencyOptions = [
    { value: ScheduledTransferFrequencyUnit.Day, label: 'Day(s)' },
    { value: ScheduledTransferFrequencyUnit.Week, label: 'Week(s)' },
    { value: ScheduledTransferFrequencyUnit.Month, label: 'Month(s)' },
  ];

  const handleOccurrencesChange = (value: string) => {
    if (value === '') {
      setFieldValue('transfer.occurrences', undefined);
      return;
    }
    const parsedValue = parseInt(value);
    if (isNaN(parsedValue) || parsedValue < 0) {
      setFieldValue('transfer.occurrences', undefined);
    } else {
      setFieldValue('transfer.occurrences', parsedValue);
    }
  };

  const handleStartDateChange = (value: string) => {
    setFieldValue('transfer.startDate', value);
  };

  const handleNickNameChange = (value: string) => {
    setFieldValue('transfer.nickName', value);
  };

  return (
    <div>
      <p className="fields-title">Scheduled Transfer Details</p>
      <FormGroup title="Nickname">
        <Field
          component={TextboxField}
          id="transfer.nickName"
          name="transfer.nickName"
          placeholder="Nickname"
          value={transfer && transfer.nickName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleNickNameChange(e.target.value)}
        />
      </FormGroup>
      <FormGroup title="Repeat every">
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', width: '100%' }}>
          <Field
            component={TextboxField}
            id="transfer.frequencyInterval"
            name="transfer.frequencyInterval"
            type="number"
            min={1}
            placeholder="Interval"
            style={{ width: 120, minWidth: 120 }}
          />
          <Field
            component={SelectDropdownInput}
            id="transfer.frequencyUnit"
            name="transfer.frequencyUnit"
            options={frequencyOptions}
            style={{ flex: 1 }}
            value={transfer && transfer.frequencyUnit}
            onchange={(_e: any, value: any) => setFieldValue('transfer.frequencyUnit', value)}
          />
        </div>
      </FormGroup>
      <FormGroup title="Occurrences">
        <Field
          component={TextboxField}
          id="transfer.occurrences"
          name="transfer.occurrences"
          type="number"
          min={0}
          placeholder="Occurrences (leave blank or 0 for until cancelled)"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOccurrencesChange(e.target.value)}
        />
      </FormGroup>
      <FormGroup title="Start date">
        <Field
          component={DateField}
          id="transfer.startDate"
          name="transfer.startDate"
          placeholder="Start date"
          value={transfer && transfer.startDate}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleStartDateChange(e.target.value)}
          futureOnly
        />
      </FormGroup>
    </div>
  );
};
